import { EventCardDescription } from '@components/UnitCalendarPage/UnitCalendarPageContext/EventCardDescriptionType';

const DEFAULT_SELECTED_EVENT: EventCardDescription = {
	eventInfo: undefined,
	elmCard: null,
};

export default DEFAULT_SELECTED_EVENT;
